<template>
    <el-tabs v-model="selectTabName" type="card" @edit="handleTabsEdit" @tab-click="handleTabsClick">
        <el-tab-pane closable :key="item.name"
                     v-for="(item) in editableTabs"
                     :name="item.name">
            <el-tooltip :content="item.title" placement="bottom" slot="label">
                <span><i :class="item.icon"></i> {{item.title.length>30?item.title.substr(0,30)+'...':item.title}}</span>
            </el-tooltip>
            <component 
                       :ref="item.name" 
                       :is="item.component" 
                       :tableName="item.params.tablename" 
                       :tableNameTree="item.params.tablenameTree" 
                       :columnTree="item.params.columnTree" 
                       :callbackParam.sync="item.params.callbackparam"
                       :tableFilterColsParamOut.sync="item.params.filter" 
                       :meta="getMetaData(item)" 
                       :isShowToolbar="item.params.isshowtoolbar" 
                       :isShowCheck="item.params.isshowcheck" 
                       :isShowFilter="item.params.isshowfilter"
                       :isDbClick="item.params.isdbclick" 
                       :loading="true"
                       >
            </component>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
    import Datatable from '@/components/Datatable'
    import DatatableTree from '@/components/DatatableTree'
    import Detailinfo from '@/views/Detailinfo'
    import CompareObs from '@//views/CompareObs'
    import mainPage from '@//views/mainPage'
    import microStation from '@//views/microStation'
    import uploadWater from '@/views/uploadWater'
    import TdtMap from '@/components/TdtMap'

    export default {
        name: 'Tabs',
        components: {
            Datatable,
            DatatableTree,
            Detailinfo,
            CompareObs,
            mainPage,
            microStation,
            uploadWater,
            TdtMap
        },
        data() {
            return {
            }
        },
        computed: {
            editableTabs: function () {
                return this.$store.getters.editableTabs;
            },
            selectTabName: {
                get: function () {
                    return this.$store.getters.selectTabName;
                },
                set: function (newValue) {
                    this.$store.commit('app/SET_SELECTTABNAME', newValue);
                }
            }
        },
        mounted() {
            //var _this = this;
            //_this.$store.commit('app/SET_CURRENTWIDTH', _this.$refs[_this.selectTabName][0].$el.clientWidth);
            //window.onresize = function () {
            //    _this.$store.commit('app/SET_CURRENTWIDTH', _this.$refs[_this.selectTabName][0].$el.clientWidth);
            //    _this.resizeComponent();
            //}
        },
        methods: {
            getMetaData(item) {
                var meta = {};
                switch (item.component) {
                    case 'datatable':
                        meta = { 'title': item.title, 'icon': item.icon };
                        break;
                    case 'detailinfo':
                    case 'compareObs':
                        meta = { 'id': item.params.id };
                        break;
                    default:
                }
                return meta;
            },
            handleTabsEdit(targetName, action) {
                if (action === 'remove') {
                    this.$store.commit('app/REMOVE_TAB', targetName);
                }
            },
            handleTabsClick() {
                this.resizeComponent();
            },
            resizeComponent() {
                if (this.$refs[this.selectTabName][0].resize) {
                    this.$refs[this.selectTabName][0].resize();
                }
            }
        }
    }
</script>

<style scoped>
</style>